import * as React from 'react';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';

import StatusContext from '../../../contexts/StatusContext'
import './home.css'

export const DialogLogout = ({alertYes, openDialog, closeDialog}) => {

  let {
   changeLanguage,
   dialogLogoutText,

} = React.useContext(StatusContext);

  const dialogStyle = {
    padding: "20px",
    fontSize: "16px",
 };
 
  return (
    <Dialog onClose = {closeDialog} open = {openDialog}>
            <DialogTitle style={{fontSize:'12px'}}> DedaAI </DialogTitle>
            <h3 style = {dialogStyle}>
               {dialogLogoutText}
            </h3>
            <div style = {{display: 'flex', width: '100%', justifyContent:'center', alignItems: 'center'}}>
            <button className="dialogButtonYes" onClick={alertYes}>{changeLanguage('dialog', 'ok')}</button> 
            
            </div>
    </Dialog>
  );
}
